import React from 'react';
import { urlApi } from '../Constants/Global';

import SectionHeader from '../Components/SectionHeader';
import SectionCarousel from '../Components/SectionCarousel';
import SectionContact from '../Components/SectionContact';
import Bg from '../Medias/Photos/photo-bg7.jpg';
import SectionEducational from '../Components/SectionEducational';

const Educational = ({ contents }) => {
  console.log(contents)

  return (
    <>
      <SectionHeader topic='Energy Trends' detail='Understand legal topics with clear explanations and expert tips.' bg={Bg} />
      <SectionEducational youtubes={contents?.web_setup?.youtube} />
    </>
  )
}

Educational.defaultProps = {
  contents: {
    lang: 'th',
    content: {
      contents: []
    }
  },
  web_setup: {
    practice_topic: [],
    practice: []
  },
  path: '',
  lang: 'en'
}

export default Educational